import { notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'

import { QUERY_KEYS } from '@api'
import { AxiosErrorType, CarrierUpdateData } from '@types'

import { CarriersApi } from './api'

const useUpdateCarrier = (onClose: () => void) => {
  const { t } = useTranslation()
  const tPreffix = 'carriers_router.carriers_dashboard.use_update_carrier.'

  const queryClient = useQueryClient()

  const onUpdateSuccess = () => {
    queryClient.invalidateQueries(QUERY_KEYS.CARRIERS_ADMIN)
    onClose()
  }

  const updateCarrier = async (carrierId: number, updatedData: CarrierUpdateData) => {
    try {
      await CarriersApi.updateCarrier(carrierId, updatedData)
      onUpdateSuccess()
      notification.success({
        message: 'Se realizo la modificacion correctamente',
      })
    } catch (error) {
      const axiosError = error as AxiosErrorType

      if (axiosError && axiosError.data && axiosError.data.error) {
        const errorResponse = axiosError.data.error
        const { type, message } = errorResponse

        if (type === 'SOME_ERROR_TYPE') {
          const hint =
            message.length > 62
              ? `${t(`${tPreffix}no_active_route_hint`)} ${message.substring(62)}`
              : `${t(`${tPreffix}no_active_route_at_all_hint`)}`

          notification.error({
            message: `${t(`${tPreffix}no_active_route`)} ${hint}`,
          })
        } else {
          notification.error({
            message: 'No se realizo la modificacion',
          })
        }
      } else {
        console.error('Error:', axiosError)
      }
    }
  }

  return {
    updateCarrier,
  }
}

export { useUpdateCarrier }
